/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-unresolved */
/* eslint-disable jsx-a11y/label-has-associated-control */
import { useEffect, useState } from 'react';
import { useMutation, useQuery } from '@apollo/client';
import {
    Button, Input, Modal, ModalBody, ModalHeader, Select, SelectOption, TextArea,
} from 'appkit-react';

import { COPY_PROJECT, CREATE_PROJECT, UPDATE_PROJECT } from 'Apollo/Mutations/DataRecon';
import {
    GET_PROJECTS,
} from 'Apollo/Queries/DataRecon';
import { GET_USERS } from 'Apollo/Queries';
import Loader from 'views/Shared/components/Loader';
import './CreateProjectModal.scss';

const CreateProjectModal = (
    {
        visibleFlag, setShowModal, projectData, tenantId, dataForClone, copyProjectFlag, setCopyProjectFlag, fetchData, setToastMessage,
    },
) => {
    const [visible, setVisible] = useState(visibleFlag);
    const [projectName, setProjectName] = useState('');
    const [description, setDescription] = useState('');
    const [parentProject, setParentProject] = useState('');
    const [ownerId, setOwnerId] = useState('');
    const [projectUsers, setProjectUsers] = useState([]);
    const [parentProjectDisplayId, setParentProjectDisplayId] = useState();
    const [disableParentSelect, setDisableParentSelect] = useState(false);

    const [nameError, setNameError] = useState(false);
    const [descriptionError, setDescriptionError] = useState(false);
    const [ownerError, setOwnerError] = useState(false);

    /* apollo query to fetch the project users */
    const users = useQuery(GET_USERS, {
        variables: {
            input: {
                tenantId: parseInt(tenantId, 10),
                getAll: true,
            },
        },
    });

    /* apollo query to fetch all parent projects */
    const parentPojects = useQuery(GET_PROJECTS, {
        variables: {
            input: {
                tenantId: parseInt(tenantId, 10),
            },
        },
    });

    /* apollo mutation to create the project */
    const [createProject, { loading }] = useMutation(CREATE_PROJECT, {
        variables: {
            input: {
                projectName,
                tenantId: parseInt(tenantId, 10),
                projectDesc: description,
                parentProjectId: parseInt(parentProject, 10),
                displayIdOfParent: parentProjectDisplayId,
                userIdArr: projectUsers,
                ownerId: parseInt(ownerId, 10),
                status: 'open',
            },
        },
    });

    /* apollo mutation to update the project */
    const [updateProject, { loading: projectUpdateloading }] = useMutation(UPDATE_PROJECT, {
        variables: {
            input: {
                projectName,
                projectId: parseInt(projectData && projectData.projectId, 10),
                projectDesc: description,
                userIdArr: projectUsers,
                ownerId: parseInt(ownerId, 10),
                tenantId: parseInt(tenantId, 10),
            },
        },
    });

    /* apollo mutation to copy the project */
    const [copyProject, { loading: copyProjectLoading }] = useMutation(COPY_PROJECT, {
        variables: {
            input: {
                projectName,
                tenantId: parseInt(tenantId, 10),
                copyProjectId: parseInt(dataForClone && dataForClone.projectId, 10),
                projectDesc: description,
                parentProjectId: parseInt(parentProject, 10),
                displayIdOfParent: parentProjectDisplayId,
                userIdArr: projectUsers,
                ownerId: parseInt(ownerId, 10),
                status: 'open',
            },
        },
    });

    /* side effect called when parentProject is changed */
    useEffect(() => {
        let result;
        if (parentPojects.data) {
            result = parentPojects.data.getProjects.find(project => project.projectId === parentProject);
        }
        if (result) {
            setParentProjectDisplayId(result.projectDisplayId);
        }
    }, [parentProject]);

    /* side effect called when projectData is changed */
    useEffect(() => {
        if (projectData && projectData.projectId) {
            setProjectName(projectData.projectName);
            setDescription(projectData.projectDesc);
            setParentProject(projectData.parentProjectId);
            setOwnerId(projectData.ownerId);
            setProjectUsers(projectData.userIdArr);
            setDisableParentSelect(true);
        } else {
            setProjectName('');
            setDescription('');
            setParentProject('');
            setOwnerId('');
            setProjectUsers([]);
            setDisableParentSelect(false);
        }
    }, [projectData]);

    /* side effect called when clone data for project is changed */
    useEffect(() => {
        if (dataForClone && dataForClone.projectId) {
            setProjectName(dataForClone.projectName);
            setDescription(dataForClone.projectDesc);
            setParentProject(dataForClone.parentProjectId);
            setOwnerId(dataForClone.ownerId);
            setProjectUsers(dataForClone.userIdArr);
            setParentProjectDisplayId(dataForClone.projectDisplayId);
        }
    }, [dataForClone]);

    const projectNameBlurHandler = (event => {
        if (event.target.value.trim() === '') {
            setNameError(true);
        } else {
            setNameError(false);
        }
    });

    const descriptionBlurHandler = (event => {
        if (event.target.value.trim() === '') {
            setDescriptionError(true);
        } else {
            setDescriptionError(false);
        }
    });
    const onCloseProjectOwner = () => {
        if (ownerId === '') {
            setOwnerError(true);
        } else {
            setOwnerError(false);
        }
    };

    const onChangeProjectName = value => {
        if (value.trim() === '') {
            setNameError(true);
        } else {
            setNameError(false);
        }
    };

    const onChangeDescription = value => {
        if (value.trim() === '') {
            setDescriptionError(true);
        } else {
            setDescriptionError(false);
        }
    };

    /* function to validate Input before Create Project Form is submitted */
    const handleInput = async () => {
        if (projectName.trim() === '' || description.trim() === '' || ownerId === '') {
            return;
        }
        onChangeProjectName(projectName);
        onChangeDescription(description);
        onCloseProjectOwner();

        if (copyProjectFlag && dataForClone) {
            await copyProject().then(() => setToastMessage('Project cloning is complete.'));
            parentPojects.refetch();
            setCopyProjectFlag(false);
            setShowModal(false);
            fetchData();
        } else if (projectData && projectData.projectId) {
            await updateProject().then(() => setToastMessage('Project is updated.'));
            parentPojects.refetch();
            setShowModal(false);
            fetchData();
        } else {
            await createProject().then(() => setToastMessage('Project is created.'));
            parentPojects.refetch();
            setShowModal(false);
            fetchData();
        }

        setNameError(false);
        setDescriptionError(false);
        setOwnerError(false);
    };

    /* function to handle modal close */
    const handleModalClose = () => {
        setVisible(false);
        setShowModal(false);
        setCopyProjectFlag(false);
    };

    const errorCss = {
        boxShadow: '0 0 0 0.125rem #c52a1a',
        borderRadius: '3px',
    };

    const getModalTitle = () => {
        let title;
        if (copyProjectFlag) {
            title = 'Clone Project';
        } else if (projectData && projectData.projectId) {
            title = 'UPDATE PROJECT';
        } else {
            title = 'CREATE PROJECT';
        }
        return title;
    };

    return (
        <div>
            <Modal
                className="add-and-edit-modal create-project-modal"
                visible={visible}
                onCancel={handleModalClose}
            >
                <ModalHeader>
                    <div className="a-modal-header">
                        <div className="modal-title-left">
                            <div className="modal-title">{getModalTitle()}</div>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    {users?.data?.getUsers && (
                        <div className="edit-form-container">
                            <div className="edit-form-input-right-col">
                                <label className="a-h6">Project Name * </label>
                                <Input
                                    type="text"
                                    name="projectName"
                                    value={projectName}
                                    hasError={nameError}
                                    errMsg="Project Name is required"
                                    onBlur={projectNameBlurHandler}
                                    onChange={e => {
                                        setProjectName(e);
                                        onChangeProjectName(e);
                                    }}
                                />

                                <label className="a-h6">Description * </label>
                                <TextArea
                                    value={description}
                                    onChange={e => {
                                        setDescription(e);
                                        onChangeDescription(e);
                                    }}
                                    onBlur={descriptionBlurHandler}
                                    name="description"
                                    style={descriptionError ? errorCss : {}}
                                />
                                {descriptionError && <div className="custom-validation-text">Description is required</div>}

                                <label className="a-h6">Parent Project </label>
                                <Select
                                    placeholder="Select"
                                    onSelect={e => { setParentProject(e); }}
                                    showSearchOnList
                                    value={parentProject}
                                    name="parentProject"
                                    disabled={disableParentSelect}
                                >
                                    {
                                        parentPojects.data && parentPojects.data.getProjects
                                            .map(project => (
                                                <SelectOption
                                                    key={project.projectId}
                                                    value={project.projectId}
                                                >
                                                    {project.projectName}
                                                </SelectOption>
                                            ))
                                    }
                                </Select>

                                <label className="a-h6">Project Owner * </label>
                                <Select
                                    placeholder="Select"
                                    onSelect={e => setOwnerId(e)}
                                    showSearchOnList
                                    value={ownerId}
                                    onClose={onCloseProjectOwner}
                                    name="projectOwner"
                                    style={ownerError ? errorCss : {}}
                                >
                                    {
                                        users.data && (users.data.getUsers || []).map(user => <SelectOption key={user.userId} value={user.userId}>{user.fullName}</SelectOption>)
                                    }
                                </Select>
                                {ownerError && <div className="custom-validation-text">Project Owner is required</div>}

                                <label className="a-h6">Project Users </label>
                                <Select
                                    placeholder="Select"
                                    onSelect={e => setProjectUsers(e)}
                                    showSearchOnList
                                    value={projectUsers}
                                    multiple
                                    name="projectUsers"
                                >
                                    {
                                        users.data && (users.data.getUsers || []).map(user => <SelectOption key={user.userId} value={user.userId}>{user.fullName}</SelectOption>)
                                    }
                                </Select>
                            </div>
                            <div className="button-comp">
                                <Button
                                    className="a-btn a-btn-primary a-btn-lg"
                                    size="lg"
                                    onClick={handleInput}
                                    isLoading={loading || projectUpdateloading || copyProjectLoading}
                                >
                                    SAVE
                                </Button>
                                <Button
                                    className="a-btn a-btn-secondary a-btn-lg "
                                    kind="secondary"
                                    onClick={handleModalClose}
                                    size="lg"
                                >
                                    CANCEL
                                </Button>
                            </div>
                        </div>
                    )}
                    {users.data === null && !users.loading && (
                        <div>
                            No users available for this tenant
                        </div>
                    )}
                    {users.loading && (
                        <Loader />
                    )}
                </ModalBody>
            </Modal>
        </div>
    );
};

export default CreateProjectModal;
